import React from "react"

import Layout from "../components/layouts/layout"
import SEO from "../components/seo"

const IndexPage = () => {
  return (
    <Layout tab="Home">
      <SEO title="Home" />
    </Layout>
  )
}

export default IndexPage
